import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <header className="bg-white shadow-md" data-id="element-62">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-63">
        <div className="flex justify-between h-16" data-id="element-64">
          <div className="flex items-center" data-id="element-65">
            <Link to="/" className="flex items-center" data-id="element-66">
              <span className="text-2xl font-bold text-emerald-800" data-id="element-67">
                Emirati<span className="text-amber-500" data-id="element-68">Match</span>
              </span>
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8" data-id="element-69">
            <Link to="/" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-70">
              Home
            </Link>
            <Link to="/dashboard" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-71">
              Dashboard
            </Link>
            <Link to="/profile-setup" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-72">
              Profile
            </Link>
            <Link to="/guardian" className="text-gray-700 hover:text-emerald-700 font-medium" data-id="element-73">
              Guardian Mode
            </Link>
            <Link to="/profile-setup" className="bg-emerald-700 hover:bg-emerald-800 text-white font-bold py-2 px-4 rounded-full transition duration-300" data-id="element-74">
              Sign Up
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-75">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-emerald-700 focus:outline-none" data-id="element-76">
              {mobileMenuOpen ? <X className="h-6 w-6" data-id="element-77" /> : <Menu className="h-6 w-6" data-id="element-78" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation */}
      {mobileMenuOpen && <div className="md:hidden" data-id="element-79">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white shadow-lg" data-id="element-80">
            <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-emerald-700 font-medium" data-id="element-81">
              Home
            </Link>
            <Link to="/dashboard" className="block px-3 py-2 text-gray-700 hover:text-emerald-700 font-medium" data-id="element-82">
              Dashboard
            </Link>
            <Link to="/profile-setup" className="block px-3 py-2 text-gray-700 hover:text-emerald-700 font-medium" data-id="element-83">
              Profile
            </Link>
            <Link to="/guardian" className="block px-3 py-2 text-gray-700 hover:text-emerald-700 font-medium" data-id="element-84">
              Guardian Mode
            </Link>
            <Link to="/profile-setup" className="block px-3 py-2 bg-emerald-700 text-white font-bold rounded-md" data-id="element-85">
              Sign Up
            </Link>
          </div>
        </div>}
    </header>;
};
export default Header;